import { IChangeLog, IChangeLogWithName } from '~/src/dash/views/publisher/change-logs/interfaces';
import {
  ActionTakenCreate,
  ActionTakenDelete,
  ActionTakenUpdate,
} from '~/src/dash/views/publisher/change-logs/types';

export const dataToRow = (changeLogData: IChangeLog[]): IChangeLogWithName[] => {
  return (changeLogData || []).map((changeLog: IChangeLog): IChangeLogWithName => {
    let ActionTaken = '';
    switch (changeLog.ActionTaken) {
      case ActionTakenCreate:
        ActionTaken = 'Create';
        break;
      case ActionTakenUpdate:
        ActionTaken = 'Update';
        break;
      case ActionTakenDelete:
        ActionTaken = 'Delete';
        break;
      default:
        ActionTaken = 'Unknown';
        break;
    }
    let itemChanged = '';
    switch (changeLog.TableAffected) {
      case 'adserver_campaign':
        itemChanged = changeLog.AdserverCampaignName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'adserver_order':
        itemChanged = changeLog.AdserverOrderName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'automated_bid_floors':
        itemChanged = `Smart Floor (${changeLog.AffectedItemID})`;
        break;
      case 'bidder_group':
        itemChanged = changeLog.BidderGroupName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'brand_safety_rules':
        itemChanged = changeLog.BrandSafetyRuleName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'channel_group':
        itemChanged = changeLog.ChannelGroupName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'company':
        itemChanged = changeLog.CompanyName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'deals':
        itemChanged = changeLog.DealName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'deal_to_headerbidder_association':
        itemChanged = changeLog.AffectedItemID;
        break;
      case 'deal_to_channel_association':
        itemChanged = changeLog.AffectedItemID;
        break;
      case 'deal_to_channel_group_association':
        itemChanged = changeLog.AffectedItemID;
        break;
      case 'deal_to_contextual_segment_association':
        itemChanged = changeLog.AffectedItemID;
        break;
      case 'headerbidder_to_channel_association':
        itemChanged = changeLog.AffectedItemID;
        break;
      case 'headerbidders':
        itemChanged = changeLog.HeaderBidderName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'networks':
        itemChanged = changeLog.NetworkName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'platform_connections':
        itemChanged = `Platform Connection (${changeLog.AffectedItemID})`;
        break;
      case 'publishers':
        itemChanged = Object.keys(changeLog.ChangesMade).join(', ');
        break;
      case 'reports':
        itemChanged = `${changeLog.ReportName} (${changeLog.AffectedItemID})`;
        break;
      case 'routes':
        itemChanged = changeLog.RouteName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'sites':
        itemChanged = changeLog.SiteName + ` (${changeLog.AffectedItemID})`;
        break;
      case 'smart_floor_configs':
        itemChanged = `Smart Floor Config (${changeLog.AffectedItemID})`;
        break;
      default:
        itemChanged = 'Unknown' + ` (${changeLog.AffectedItemID})`;
        break;
    }
    return {
      CreatedAt: changeLog.CreatedAt,
      UserName: changeLog.UserName + ` (${changeLog.UserID})`,
      TableChanged: changeLog.TableAffected,
      ItemChanged: itemChanged,
      AffectedItemID: changeLog.AffectedItemID,
      ActionTaken,
      ChangesMade: changeLog.ChangesMade,
    };
  });
};
